import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";
import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import { Disc3, Ticket, Cherry, Goal, LucideIcon } from "lucide-react";
import { STATUS_LABELS } from '../../utils/status';
import { useGamificationFilterActions } from "../../ducks/filter/hooks/actions";
import { useFilterState } from "../../ducks/filter/hooks/filterState";
import {
  CampaignType,
  CAMPAIGN_TYPE_LABELS,
} from "../../../../../@types/gamification";

const MECHANIC_ICONS: Record<CampaignType, LucideIcon> = {
  ROULETTE: Disc3,
  SCRATCH: Ticket,
  SLOT: Cherry,
  PENALTY: Goal,
};

const MECHANIC_ORDER: CampaignType[] = [
  CampaignType.ROULETTE,
  CampaignType.SCRATCH,
  CampaignType.SLOT,
  CampaignType.PENALTY,
];

export default function SelectFilters() {
  const { updateFilter } = useGamificationFilterActions();
  const filterState = useFilterState();
  const { filters } = filterState || { filters: {} };

  return (
    <>
      <div className="flex min-w-0 flex-col gap-2">
        <Label htmlFor="campaign-type-filter" className="text-sm">Tipo</Label>
        <Select
          value={filters.campaignType ?? "all"}
          onValueChange={(value) => {
            updateFilter({
              key: "campaignType",
              value: value === "all" ? undefined : (value as CampaignType),
            });
          }}
        >
          <SelectTrigger className="h-8 w-full" id="campaign-type-filter">
            <SelectValue placeholder="Tipo" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todas as mecânicas</SelectItem>
            {MECHANIC_ORDER.map((mechanic) => {
              const Icon = MECHANIC_ICONS[mechanic];
              return (
                <SelectItem key={mechanic} value={mechanic}>
                  <span className="flex items-center gap-2">
                    <Icon className="h-4 w-4" aria-hidden="true" />
                    {CAMPAIGN_TYPE_LABELS[mechanic]}
                  </span>
                </SelectItem>
              );
            })}
          </SelectContent>
        </Select>
      </div>

      <div className="flex min-w-0 flex-col gap-2">
        <Label htmlFor="status-filter" className="text-sm">Status</Label>
        <Select
          value={filters.status || "all"}
          onValueChange={(value) => {
            updateFilter({ key: "status", value: value === "all" ? "" : value });
          }}
        >
          <SelectTrigger className="h-8 w-full" id="status-filter">
            <SelectValue placeholder="Status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos os status</SelectItem>
            {Object.entries(STATUS_LABELS).map(([status, label]) => (
              <SelectItem key={status} value={status}>
                {label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="flex min-w-0 flex-col gap-2">
        <Label htmlFor="period-start" className="text-sm">Período - Início</Label>
        <Input
          id="period-start"
          type="date"
          className="h-8 w-full"
          value={filters.periodStart || ""}
          onChange={(e) => {
            updateFilter({ key: "periodStart", value: e.target.value });
            updateFilter({ key: "meta", value: { page: 1, perPage: filters.meta?.perPage || 10 } });
          }}
        />
      </div>

      <div className="flex min-w-0 flex-col gap-2">
        <Label htmlFor="period-end" className="text-sm">Período - Fim</Label>
        <Input
          id="period-end"
          type="date"
          className="h-8 w-full"
          value={filters.periodEnd || ""}
          onChange={(e) => {
            updateFilter({ key: "periodEnd", value: e.target.value });
            updateFilter({ key: "meta", value: { page: 1, perPage: filters.meta?.perPage || 10 } });
          }}
        />
      </div>
    </>
  );
}
